export default __webpack_public_path__ + "src/assets/Okta_Wordmark_Black_S.png";